import axios from 'axios';
import { routePrefix } from '../app/App';
import { AuthKeys } from '../dto/authorization/AuthKeys';
import { AuthResponse } from '../dto/authorization/AuthResponse';
import { FilterBaseType } from '../type/FilterBaseType';

export async function getFilterConfiguration(query: string): Promise<FilterBaseType[]> {
  const url = `${routePrefix()}filter-configuration${query}`;
  const { data } = await axios.get<FilterBaseType[]>(url);
  return data;
}

export async function getAuthKeys(): Promise<AuthKeys[]> {
  const url = `${routePrefix()}auth/keys`;
  const { data } = await axios.get<AuthResponse>(url);
  return data.keys;
}
